// removed by extract-text-webpack-plugin
module.exports = {"badge":"badge--rS-GV"};